import { ListSubheader, MenuItem, TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import React from 'react';

const styledSubheader = (text) => (
  <ListSubheader
    key={text}
    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}
  >
    <span style={{ flex: 1, height: '1px', background: '#ccc', marginRight: '8px' }}></span>
    {text}
    <span style={{ flex: 1, height: '1px', background: '#ccc', marginLeft: '8px' }}></span>
  </ListSubheader>
);

const stopMenuMouseDown = (event) => {
  event.stopPropagation();
};

const SelectField = (props) => {
  const { name = '', label, options, defaultValue = '', disabled, slotProps, ...otherProps } = props;

  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  const values = watch(name);

  return (
    <TextField
      label={label}
      fullWidth
      select
      margin='normal'
      disabled={disabled}
      defaultValue={defaultValue}
      {...register(name)}
      value={values}
      error={!!errors?.[name]}
      helperText={errors?.[name] ? errors?.[name]?.message : ''}
      slotProps={{
        ...slotProps,
        select: {
          ...slotProps?.select,
          MenuProps: {
            // Firefox treats the opening click of a portaled menu as a dialog
            // backdrop click unless the event is kept on the menu itself.
            disableAutoFocusItem: true,
            ...slotProps?.select?.MenuProps,
            PaperProps: {
              onMouseDown: stopMenuMouseDown,
              ...slotProps?.select?.MenuProps?.PaperProps,
            },
            MenuListProps: {
              onMouseDown: stopMenuMouseDown,
              ...slotProps?.select?.MenuProps?.MenuListProps,
            },
          },
        },
      }}
      {...otherProps}
    >
      {options.map((option) =>
        option.isSubheader ? (
          styledSubheader(option.value)
        ) : (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ),
      )}
    </TextField>
  );
};

export default SelectField;
